import SCHEDULE from './SCHEDULE';

export default SCHEDULE;
